const config = {
  clientToken: process.env.REACT_APP_OPENOBSERVE_CLIENT_TOKEN,
  applicationId: "atReporte",
  site: process.env.REACT_APP_OPENOBSERVE_SITE,
  organizationIdentifier: process.env.REACT_APP_OPENOBSERVE_ORG,
  service: "atReporte",
  env: process.env.REACT_APP_OPENOBSERVE_ENV,
  version: process.env.REACT_APP_OPENOBSERVE_VERSION,
  insecureHTTP: false,
  apiVersion: "v1",
};
export default config;
